<template>
  <div v-if="parentEntity" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-datasource" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-info-datasource" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("datasource.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("datasource.used-places") }}</h5>
          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>

                <td>
                  {{ i.name | translate }}
                </td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-datasource-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <b-tabs v-if="selectedBox" nav-class="nav-tabs-custom p-2 ml-3" v-model="activeTab" content-class="mt-1">
          <!-- BEGIN TAB-->
          <b-tab>
            <template v-slot:title>
              <span>
                {{ $t("inventory.filter.inventory-features") }}
              </span>
            </template>

            <div v-if="datasourceInventory" class="pl-5 pr-5">
              <h3>{{ $t("datasource.inventory", { datasource: $options.filters.translate(selectedBox.name) }) }}</h3>

              <!--Direct Collect Method-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasource-direct-collect-method-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("direct-collect-method.text") }}
                </h4>
                <b-collapse id="datasource-direct-collect-method-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasourceInventory.directCollectMethods || datasourceInventory.directCollectMethods.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <div v-for="item in datasourceInventory.directCollectMethods" :key="item._id" class="mb-1">
                      <i class="bx bx-trash text-danger hand" @click="removeDirectCollectMethod(selectedBox._id, item._id)"></i> {{ item.name | translate }}
                    </div>

                    <span class="text-primary hand" @click="editDirectCollectMethod(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Other Collect Method-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasource-other-collect-method-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("other-collect-method.text") }}
                </h4>
                <b-collapse id="datasource-other-collect-method-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasourceInventory.otherCollectMethods || datasourceInventory.otherCollectMethods.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <div v-for="item in datasourceInventory.otherCollectMethods" :key="item._id" class="mb-1">
                      <i class="bx bx-trash text-danger hand" @click="removeOtherCollectMethod(selectedBox._id, item._id)"></i> {{ item.name | translate }}
                    </div>

                    <span class="text-primary hand" @click="editOtherCollectMethod(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Physical Storage-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasource-physical-storage-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("physical-storage.text") }}
                </h4>
                <b-collapse id="datasource-physical-storage-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasourceInventory.physicalStorages || datasourceInventory.physicalStorages.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>
                    <b-row v-for="physicalStorage in datasourceInventory.physicalStorages" :key="physicalStorage._id">
                      <b-col>
                        <span class="text-warning hand float-left" @click="editPhysicalStorage(selectedBox._id, physicalStorage)">
                          <i class="bx bx-pencil"></i>
                        </span>

                        <span class="text-danger hand float-left ml-2 mr-2" @click="removePhysicalStorage(selectedBox._id, physicalStorage._id)">
                          <i class="bx bx-trash"></i>
                        </span>

                        {{ physicalStorage.name | translate }}
                        <span class="text-muted"> - {{ physicalStorage.period | period }} </span>
                        <i class="text-muted">- {{ physicalStorage.since }} </i>
                      </b-col>
                    </b-row>

                    <span class="text-primary hand" @click="addPhysicalStorage(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Electronic Storage-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasource-electronic-storage-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("electronic-storage.text") }}
                </h4>
                <b-collapse id="datasource-electronic-storage-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasourceInventory.electronicStorages || datasourceInventory.electronicStorages.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <b-row v-for="electronicStorage in datasourceInventory.electronicStorages" :key="electronicStorage._id">
                      <b-col>
                        <span class="text-warning hand float-left" @click="editElectronicStorage(selectedBox._id, electronicStorage)">
                          <i class="bx bx-pencil"></i>
                        </span>

                        <span class="text-danger hand float-left ml-2 mr-2" @click="removeElectronicStorage(selectedBox._id, electronicStorage._id)">
                          <i class="bx bx-trash"></i>
                        </span>

                        {{ electronicStorage.name | translate }}
                        <span class="text-muted"> - {{ electronicStorage.period | period }} </span>
                        <i class="text-muted">- {{ electronicStorage.since }} </i>
                      </b-col>
                    </b-row>

                    <span class="text-primary hand" @click="addElectronicStorage(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Physical Archive-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasource-physical-archive-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("physical-archive.text") }}
                </h4>
                <b-collapse id="datasource-physical-archive-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasourceInventory.physicalArchives || datasourceInventory.physicalArchives.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <div v-for="item in datasourceInventory.physicalArchives" :key="item._id" class="mb-1">
                      <i class="bx bx-trash text-danger hand" @click="removePhysicalArchive(selectedBox._id, item._id)"></i> {{ item.name | translate }}
                    </div>

                    <span class="text-primary hand" @click="editPhysicalArchive(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Electronic Archive-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasource-electronic-archive-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("electronic-archive.text") }}
                </h4>
                <b-collapse id="datasource-electronic-archive-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasourceInventory.electronicArchives || datasourceInventory.electronicArchives.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <div v-for="item in datasourceInventory.electronicArchives" :key="item._id" class="mb-1">
                      <i class="bx bx-trash text-danger hand" @click="removeElectronicArchive(selectedBox._id, item._id)"></i> {{ item.name | translate }}
                    </div>

                    <span class="text-primary hand" @click="editElectronicArchive(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <hr />
            </div>

            <content-loading v-if="isDatasourceInventoryLoading" />
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <span>
                {{ $t("inventory.bulk-update.text") }}
              </span>
            </template>

            <BulkUpdateView @onUpdated="onBulkUpdated" />
          </b-tab>
        </b-tabs>
      </right-panel>
      <template v-if="selectedBox">
        <right-panel class="float-right" id="sidebar-new-datasource-direct-collect-method" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceDirectCollectMethodForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-other-collect-method" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceOtherCollectMethodForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-physical-archive" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourcePhysicalArchiveForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-electronic-archive" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceElectronicArchiveForm />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-physical-storage" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourcePhysicalStorageForm id="sidebar-new-datasource-physical-storage" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasource-electronic-storage" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasourceElectronicStorageForm />
          </div>
        </right-panel>
      </template>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span v-html="$t('datasource.owned-list', { department: $options.filters.translate(parentEntity.department.name), name: $options.filters.translate(parentEntity.name) })">
          </span>
        </span>

        <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
          <div class="d-flex align-items-center">
            <label class="switch-label">{{ $t("common.recommendations") }}</label>
            <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div class="search2 mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="actions d-flex justify-content-end p-2" style="top:0">
            <div class="action" @click="redirectToRelatedFiles(item)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page"></i>
            </div>
            <div class="action" @click="saveWorkspaceDefault(item)" v-on:click.stop v-b-tooltip.hover :title="$t('workspace-defaults.datasource-data-add')">
              <i class="bx bx-receipt"></i>
            </div>
          </div>
          <div class="text">{{ item.name | translate }}</div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" v-if="hasUpdatePermission" @click="markAsComplete(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.completed')">
              <i :class="item.completed ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            </div>
            <div class="action" @click="fetchInfo(item.datasource)" v-on:click.stop v-b-toggle="'sidebar-info-datasource'" v-b-tooltip.hover :title="$t('datasource.used-places')">
              <i class="iconoir-info-circle"></i>
            </div>

            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
      <recommendation-boxes
        v-if="parentEntity"
        :id="parentEntity._id"
        :show="showRecommendationBoxes"
        :level="libraryScopedState"
        :libraryScopedState="libraryScopedState"
        organizationScopedState="organizationProcessDatasource"
        @interceptForSetParent="interceptForSetParent"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
        :title="$t('datasource.recommendations')"
      />
    </div>
  </div>
</template>

<script>
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import DatasourceDirectCollectMethodForm from "@modules/inventory/component/direct-collect-method/datasource-direct-collect-method-form";
import DatasourceElectronicArchiveForm from "@modules/inventory/component/electronic-archive/datasource-electronic-archive-form";
import DatasourceElectronicStorageForm from "@modules/inventory/component/electronic-storage/datasource-electronic-storage-form";
import DatasourceOtherCollectMethodForm from "@modules/inventory/component/other-collect-method/datasource-other-collect-method-form";
import DatasourcePhysicalArchiveForm from "@modules/inventory/component/physical-archive/datasource-physical-archive-form";
import DatasourcePhysicalStorageForm from "@modules/inventory/component/physical-storage/datasource-physical-storage-form";
import Form from "../../process-datasource/organization-process-datasource-form";
import RecommendationBoxes from "./recommendation-boxes";

export default {
  components: {
    Form,
    RecommendationBoxes,
    DatasourceDirectCollectMethodForm,
    DatasourceOtherCollectMethodForm,
    DatasourcePhysicalArchiveForm,
    DatasourceElectronicArchiveForm,
    DatasourceElectronicStorageForm,
    DatasourcePhysicalStorageForm,
    BulkUpdateView,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "datasource",
      showRecommendationBoxes: undefined,

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },

      activeTab: null,
    };
  },
  computed: {
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/process"];
    },
    pagination() {
      return this.$store.getters["organizationProcessDatasource/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationProcessDatasource/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationDatasource/infoItem"];
    },
    info() {
      return this.$store.getters["organizationDatasource/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationDatasource/isInfoLoading"];
    },

    //inventory
    productInventoryStore() {
      return this.currentProduct == "GDPR" ? "gdprInventory" : "kvkkInventory";
    },
    datasourceInventory() {
      const inventory = this.$store.getters[this.productInventoryStore + "/datasourceInventory"];

      if (!inventory || !this.selectedBox?._id) return null;
      return inventory[this.selectedBox._id];
    },
    isDatasourceInventoryLoading() {
      return this.$store.getters[this.productInventoryStore + "/isDatasourceInventoryLoading"];
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/datasource"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      //this.showRecommendationBoxes = false;
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "datasource");
      this.$store.commit("organizationProcessDatasource/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDatasource = this.$store.getters["entityBoxes/datasource"];
        if (selectedDatasource) {
          await this.selectBox(selectedDatasource);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    async saveWorkspaceDefault(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`workspaceDatasourceData/saveFromDatasource`, item._id);
        this.paginate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { timeout: 5000 });
      }
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { datasource: item._id, datasourceName: item.name?.[this.currentLanguage] } });
    },
    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        process: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      await this.$store.dispatch("organizationProcessDatasource/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationProcessDatasource/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.process = this.parentEntity;
    },

    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationProcessDatasource/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    async markAsComplete(item) {
      try {
        await this.$store.dispatch("organizationProcessDatasource/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    edit(item) {
      this.$store.commit("organizationProcessDatasource/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationProcessDatasource/editedEntity");
      this.$store.commit("organizationProcessDatasource/copingEntity");
      // this.$store.dispatch("organizationProcessDatasource/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },
    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectDatasource", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationDatasource/fetchInfo", { item, pagination: this.infoRequest });
    },

    copyToForm(item) {
      this.$store.commit(`organizationProcessDatasource/copingEntity`, { ...item, libraryItem: item, _id: undefined, process: this.parentEntity });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource");
    },

    openRightPanel() {
      const process = this.$store.getters["entityBoxes/process"];
      this.$store.commit(`organizationDepartmentProcess/selectedEntity`, process);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource");
    },

    //inventory

    onBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-datasource-inventory");
    },
    async inventoryRightPanelClosed() {
      const datasources = [{ _id: this.selectedBox._id }];
      await this.$store.dispatch(this.productInventoryStore + "/fetchDatasourceInventory", { datasources });
    },

    async showInventoryPanel(item) {
      this.$store.commit("entityBoxes/datasource", item);
      this.$store.commit("organizationProcessDatasource/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item.process.department);
      this.$store.commit("inventoryFilter/process", item.process);
      this.$store.commit("inventoryFilter/datasource", item);

      const datasources = [item];

      this.$root.$emit("bv::toggle::collapse", "sidebar-datasource-inventory");
      await this.$store.dispatch(this.productInventoryStore + "/fetchDatasourceInventory", { datasources });
    },
    async removeDirectCollectMethod(datasourceId, directCollectMethodId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceDirectCollectMethod/delete", directCollectMethodId);
        this.$store.commit(this.productInventoryStore + "/removeDirectCollectMethod", { datasourceId, directCollectMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async removeOtherCollectMethod(datasourceId, otherCollectMethodId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceOtherCollectMethod/delete", otherCollectMethodId);
        this.$store.commit(this.productInventoryStore + "/removeOtherCollectMethod", { datasourceId, otherCollectMethodId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async removePhysicalStorage(datasourceId, physicalStorageId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourcePhysicalStorage/delete", physicalStorageId);
        this.$store.commit(this.productInventoryStore + "/removePhysicalStorage", { datasourceId, physicalStorageId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async removeElectronicStorage(datasourceId, electronicStorageId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceElectronicStorage/delete", electronicStorageId);
        this.$store.commit(this.productInventoryStore + "/removeElectronicStorage", { datasourceId, electronicStorageId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async removePhysicalArchive(datasourceId, physicalArchiveId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourcePhysicalArchive/delete", physicalArchiveId);
        this.$store.commit(this.productInventoryStore + "/removePhysicalArchive", { datasourceId, physicalArchiveId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async removeElectronicArchive(datasourceId, electronicArchiveId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasourceElectronicArchive/delete", electronicArchiveId);
        this.$store.commit(this.productInventoryStore + "/removeElectronicArchive", { datasourceId, electronicArchiveId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editDirectCollectMethod(datasource) {
      this.$store.commit("datasourceDirectCollectMethod/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-direct-collect-method");
    },
    editOtherCollectMethod(datasource) {
      this.$store.commit("datasourceOtherCollectMethod/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-other-collect-method");
    },

    addPhysicalStorage(datasource) {
      this.$store.commit("datasourcePhysicalStorage/editedDatasource", datasource);
      this.$store.commit("datasourcePhysicalStorage/editedPhysicalStorage", {});
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-physical-storage");
    },
    editPhysicalStorage(datasource, storage) {
      this.$store.commit("datasourcePhysicalStorage/editedDatasource", datasource);
      this.$store.commit("datasourcePhysicalStorage/editedPhysicalStorage", storage);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-physical-storage");
    },
    addElectronicStorage(datasource) {
      this.$store.commit("datasourceElectronicStorage/editedDatasource", datasource);
      this.$store.commit("datasourceElectronicStorage/editedElectronicStorage", {});
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-electronic-storage");
    },
    editElectronicStorage(datasource, storage) {
      this.$store.commit("datasourceElectronicStorage/editedDatasource", datasource);
      this.$store.commit("datasourceElectronicStorage/editedElectronicStorage", storage);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-electronic-storage");
    },
    editPhysicalArchive(datasource) {
      this.$store.commit("datasourcePhysicalArchive/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-physical-archive");
    },
    editElectronicArchive(datasource) {
      this.$store.commit("datasourceElectronicArchive/editedDatasource", datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-electronic-archive");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>

<style scoped>
.when-opened,
.when-closed {
  font-size: 20px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
